import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateSignupFormSplitStatus = {
  name: "updateSignupFormSplitStatus" as const,
  input: z.object({ splitId: zExt.objectId(), active: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
